/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MintGatewayLogicV1,
  MintGatewayLogicV1Interface,
} from "../MintGatewayLogicV1";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes",
        name: "_to",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_n",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "_indexedTo",
        type: "bytes",
      },
    ],
    name: "LogBurn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_n",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "_signedMessageHash",
        type: "bytes32",
      },
    ],
    name: "LogMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_newMintAuthority",
        type: "address",
      },
    ],
    name: "LogMintAuthorityUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "_directTransferOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "blacklistRecoverableToken",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes",
        name: "_to",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "burnFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimTokenOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "feeRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "_pHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
    ],
    name: "hashForSignature",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract RenERC20LogicV1",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_feeRecipient",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mintAuthority",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_mintFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_burnFee",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "_minimumBurnAmount",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_nextOwner",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "minimumBurnAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes32",
        name: "_pHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_amountUnderlying",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "mintAuthority",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "mintFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "nextN",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "recoverTokens",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "status",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract RenERC20LogicV1",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract MintGatewayLogicV1",
        name: "_nextTokenOwner",
        type: "address",
      },
    ],
    name: "transferTokenOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint16",
        name: "_nextBurnFee",
        type: "uint16",
      },
    ],
    name: "updateBurnFee",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_nextFeeRecipient",
        type: "address",
      },
    ],
    name: "updateFeeRecipient",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_minimumBurnAmount",
        type: "uint256",
      },
    ],
    name: "updateMinimumBurnAmount",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_nextMintAuthority",
        type: "address",
      },
    ],
    name: "updateMintAuthority",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint16",
        name: "_nextMintFee",
        type: "uint16",
      },
    ],
    name: "updateMintFee",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "_sigHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "verifySignature",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MintGatewayLogicV1__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MintGatewayLogicV1> {
    return super.deploy(overrides || {}) as Promise<MintGatewayLogicV1>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MintGatewayLogicV1 {
    return super.attach(address) as MintGatewayLogicV1;
  }
  connect(signer: Signer): MintGatewayLogicV1__factory {
    return super.connect(signer) as MintGatewayLogicV1__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MintGatewayLogicV1Interface {
    return new utils.Interface(_abi) as MintGatewayLogicV1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MintGatewayLogicV1 {
    return new Contract(address, _abi, signerOrProvider) as MintGatewayLogicV1;
  }
}
